<template>
  <VView class="contest-winners" header="Laureaci">
    <VText center small>
      <span>Zestaw: Lalka Monster High + Puzzle Monster High Clementoni + strój Patryka + skarpetki</span><br />
      Julia Dabrowska<br />
      Ingusia Orawiec<br />
      Julia Janisz
    </VText>

    <VText center small>
      <span>Zestaw: Lalka Monster High + Puzzle Monster High Clementoni + skarpetki</span><br />
      Gabrysia Szczepaniak <br />
      Karolina Mrozek<br />
      Lena Grosz <br />
      Kaja Urbańska-Szulc<br />
      Hanna Janczak<br />
      Julia Kmieć<br />
      Rita F.
    </VText>

    <VText center small>
      <span>Zestaw: Plecak + piórnik-tuba Monster High St. Majewski</span><br />
      Ania Wiesiołek<br />
      Asia Afzal<br />
      Ola Wiesiołek<br />
      Marta Zwolak<br />
      Maksym Gawłowski<br />
      Pola Sz.<br />
      Joanna P.<br />
      Aleksandra Ł.<br />
      Laura Ś.<br />
      Nela Urbaniak
    </VText>

  </VView>
</template>

<script>
export default {
  name: 'ContestEnd',
};
</script>

<style lang="scss" scoped>
.contest-end {}
</style>
